/**
 * i18n/index.js
 *
 * Two locales ship: english + italian. Do NOT add french here - its JSON
 * does not ship even though the backend lists it as a constant.
 */
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import it from './locales/it.json';

const SUPPORTED = new Set(['en', 'it']);

function readPreferredLocale() {
  try {
    const saved = localStorage.getItem('locale');
    if (saved && SUPPORTED.has(saved)) return saved;
  } catch { /* localStorage may be unavailable */ }
  // Browser fallback - match the first matching language family.
  try {
    const navLang = (navigator?.language || '').slice(0, 2).toLowerCase();
    if (SUPPORTED.has(navLang)) return navLang;
  } catch { /* SSR-safe */ }
  return 'en';
}

const i18n = createI18n({
  legacy: false,
  locale: readPreferredLocale(),
  fallbackLocale: 'en',
  messages: { en, it },
});

export default i18n;
